import { UPDATE_USER } from "../constants/User";

const initUser = {
	id: null,
	name: null,
	role: null,
	funcionario_info: null,
	tem_acesso_programa_indicacao: false,
	pode_importar_mfit: false,
	pode_importar_prime: false,
	pode_importar_webdiet: false,
	foto_perfil: null,
};

const user = (state = initUser, action) => {
	switch (action.type) {
		case UPDATE_USER:
			return {
				...state,
				id: action.id,
				name: action.name,
				role: action.role,
				funcionario_info: action.funcionario_info || null,
				tem_acesso_programa_indicacao:
					action.tem_acesso_programa_indicacao || false,
				pode_importar_mfit: action.pode_importar_mfit || false,
				pode_importar_prime: action.pode_importar_prime || false,
				pode_importar_webdiet: action.pode_importar_webdiet || false,
				foto_perfil: action.foto_perfil || null,
			};
		default:
			return state;
	}
};

export default user;
